import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import centerAlignedPagination from 'src/examples/Pagination/centerAligned';
import leftAlignedPagination from 'src/examples/Pagination/leftAligned';
import sizesPagination from 'src/examples/Pagination/sizes';
import lessThan7Pagination from 'src/examples/Pagination/lessThan7';
import moreThan7Pagination from 'src/examples/Pagination/moreThan7';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  centerAlignedPagination,
  leftAlignedPagination,
  sizesPagination,
  lessThan7Pagination,
  moreThan7Pagination,
  React
};